import React, { Component } from 'react';
import { LineChart, Line, XAxis, YAxis, ResponsiveContainer } from 'recharts'

import { get_nbd } from '../../util/nbd';

import {
  Container,
  Divider,
  Dropdown,
  Grid,
  Header,
  Image,
  List,
  Menu,
  Segment,
} from 'semantic-ui-react'

const m0 = 0.4125
const k0 = 0.0989

class Nbd extends Component {

  constructor(props) {
    super(props);

    this.state = {
      m: m0,
      k: k0,
      y0: get_nbd(m0, k0, 0),
      y1: get_nbd(m0, k0, 1),
      y2: get_nbd(m0, k0, 2),
      y3: get_nbd(m0, k0, 3),
      y4: get_nbd(m0, k0, 4),
      y5: get_nbd(m0, k0, 5),
      y6: get_nbd(m0, k0, 6),
      tenki: "OK",
      flag: true,
      index: 0,
      todo: [
        { title: '_list1_' },
        { title: '_list2_' },
        { title: '_list3_' },
        { title: '_list4_' },
      ],
    };

    this.handleClick = this.handleClick.bind(this);

  }

  onMInputChangeHandler = (event) => {

    this.setState({ m: event.target.value });

    console.log("m : " + this.state.m)
    console.log("k : " + this.state.k)

    this.setState({ y0: get_nbd(event.target.value, this.state.k, 0) });
    this.setState({ y1: get_nbd(event.target.value, this.state.k, 1) });
    this.setState({ y2: get_nbd(event.target.value, this.state.k, 2) });
    this.setState({ y3: get_nbd(event.target.value, this.state.k, 3) });
    this.setState({ y4: get_nbd(event.target.value, this.state.k, 4) });
    this.setState({ y5: get_nbd(event.target.value, this.state.k, 5) });
    this.setState({ y6: get_nbd(event.target.value, this.state.k, 6) });

  }

  onKInputChangeHandler = (event) => {
    console.log(event.target.value);
    console.log(event);
    this.setState({ k: event.target.value });
  }


  render() {

    const data = [
      { name: 0, pv: this.state.y0 },
      { name: 1, pv: this.state.y1 },
      { name: 2, pv: this.state.y2 },
      { name: 3, pv: this.state.y3 },
      { name: 4, pv: this.state.y4 },
      { name: 5, pv: this.state.y5 },
      { name: 6, pv: this.state.y6 },
    ]

    return (
      <Container text style={{ marginTop: '5em',"font-size":"110%" }}>
        <ResponsiveContainer width="80%" height="40%" minWidth={400} minHeight={200}>
          <LineChart width={400} height={200} data={data}>
            <XAxis dataKey="name" />
            <YAxis />
            <Line dataKey="uv" stroke="#8884d8" />
            <Line dataKey="pv" stroke="#82ca9d" />
          </LineChart>
        </ResponsiveContainer>

        <div style={{ textAlign: 'center' }}>
          <div>
            <h3>input m</h3>
          </div>
          <div>
            <input onChange={this.onMInputChangeHandler} />
          </div>
          <div>
            <h3>input k</h3>
          </div>
          <div>
            <input onChange={this.onKInputChangeHandler} />
          </div>
          <p>{this.state.keyword}</p>
        </div>

      </Container>
    )
  }

  handleClick() {
    this.setState({ index: this.state.index + 1 });

    if (this.state.index % 2 === 0) {
      this.setState({ flag: false });
    } else {
      this.setState({ flag: true });
    }
  }

}
export default Nbd;
